export const STUDY_COPY = {
  eyebrow: 'Protocolo de investigación · Memoria y lenguaje',
  researcherAccess: 'Acceso para investigadores',
  loading: 'Preparando el protocolo…',
  retry: 'Reintentar',
  loadError: 'No pudimos cargar el estudio. Comprueba tu conexión e inténtalo nuevamente.',
  blockedTitle: 'Estudio no disponible',
  blockedBody: 'El material audiovisual aún no cuenta con una fuente configurada y derechos confirmados. No se usarán videos de muestra como sustituto.',
  consentAccept: 'Acepto y deseo participar',
  consentDecline: 'No deseo participar',
  privacy: 'Tus respuestas se almacenarán con un código anónimo. No solicitamos tu nombre ni correo.',
  stepConsent: 'Consentimiento',
  stepVideo: 'Observación',
  stepQuestions: 'Preguntas',
  voluntary: 'Participación voluntaria',
  demographicsTitle: 'Antes de comenzar',
  demographicsBody: 'Estos datos permiten describir la muestra. Solo la edad es obligatoria.',
  age: 'Edad',
  ageHint: 'Debes tener 18 años o más para participar.',
  gender: 'Género (opcional)',
  genderPlaceholder: 'Prefiero no responder',
  program: 'Programa académico (opcional)',
  programPlaceholder: 'Ej. Psicología',
  continueVideo: 'Continuar al video',
  creating: 'Creando sesión anónima…',
  ageError: 'Ingresa una edad válida de 18 a 120 años.',
  sessionError: 'No pudimos confirmar la creación de tu sesión. Puedes reintentar de forma segura sin duplicarla.',
  videoTitle: 'Observa el video completo',
  videoBody: 'Míralo una vez, sin adelantar. Las preguntas aparecerán cuando el servidor verifique la reproducción completa.',
  pilotMedia: 'Material piloto',
  pilotProvenance: 'Recreación animada original creada para este proyecto. No contiene material de terceros.',
  videoProgress: 'Progreso de reproducción',
  videoLabel: 'Material audiovisual del experimento',
  videoFallback: 'Tu navegador no puede reproducir este material audiovisual.',
  videoPending: 'Verificando reproducción…',
  videoReady: 'Reproducción completa verificada',
  videoContinueBlocked: 'El avance se habilitará cuando termine el video y el servidor confirme la reproducción completa.',
  videoError: 'No pudimos verificar la reproducción. Vuelve a reproducir el video completo.',
  videoSourceError: 'No se pudo cargar el material audiovisual. Comprueba tu conexión o informa al equipo investigador.',
  continueQuestions: 'Continuar a las preguntas',
  questionsTitle: 'Recuerdo del evento',
  questionsBody: 'Responde según lo que recuerdas. No regreses al video.',
  required: 'Obligatoria',
  select: 'Selecciona una opción',
  yes: 'Sí',
  no: 'No',
  answerError: 'Completa todas las preguntas obligatorias.',
  submit: 'Enviar respuestas',
  submitting: 'Enviando respuestas…',
  submitError: 'No pudimos guardar las respuestas. Permanecen en esta pantalla para que puedas reintentar.',
  completeTitle: 'Participación completada',
  completeBody: 'Tus respuestas se guardaron correctamente. Conserva este código si necesitas contactar al equipo investigador.',
  anonymousCode: 'Código anónimo',
  thanks: 'Gracias por contribuir a este estudio sobre memoria.',
  declinedTitle: 'Has salido del estudio',
  declinedBody: 'No se creó ninguna sesión ni se guardó información. Puedes cerrar esta pestaña.',
  withdraw: 'Retirarme del estudio',
  withdrawPrompt: '¿Deseas retirarte? Se conservará únicamente el registro anónimo de retiro y no se guardarán respuestas al cuestionario.',
  withdrawConfirm: 'Sí, registrar mi retiro',
  withdrawCancel: 'Continuar participando',
  withdrawing: 'Registrando retiro…',
  withdrawError: 'No pudimos registrar el retiro. Comprueba tu conexión e inténtalo nuevamente.',
  withdrawnTitle: 'Retiro registrado',
  withdrawnBody: 'Tu sesión quedó marcada como retirada y no podrás continuar el protocolo. No se guardaron respuestas al cuestionario.',
  returnStart: 'Volver al inicio',
  mark: 'LP·74',
  duration: 'Duración',
  registry: 'Registro',
  anonymous: 'Anónimo',
  sampleData: 'Muestra · Datos permitidos',
  woman: 'Mujer',
  man: 'Hombre',
  nonBinary: 'No binario',
  other: 'Otro',
  protocol: 'Protocolo LP·74',
  footer: 'Privacidad · Accesibilidad · Participación voluntaria',
};
